import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

export const Tooltip = styled(ReactTooltip)`
  &.__react_component_tooltip {
    z-index: 99999;
  }
`;
